import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: '',
  headers: {
    'Content-Type': 'application/json',
  },
});

/** Login / code endpoints must not send a stale admin token (server may 401) and must not trigger global logout redirect. */
const isPublicAuthUrl = (url) => {
  const u = String(url || '');
  return (
    u.includes('/v1/admin/auth/login-code') ||
    u.includes('/v1/admin/auth/login') ||
    u.includes('/v1/admin/auth/forgot-password') ||
    u.includes('/v1/admin/auth/reset-password')
  );
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    const url = config.url || '';
    if (token && !isPublicAuthUrl(url)) {
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || '';
    if (status === 401 && !isPublicAuthUrl(url)) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
